import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    exportLoading: false,
    loading: false,
    tableState: {
      filter: null,
      columns: null
    }
  }),

  mutations: {
    setExportLoading: (state, newVal) => (state.exportLoading = newVal),
    setLoading: (state, newVal) => (state.loading = newVal),
    setTableStateFilter: (state, payload) => (state.tableState.filter = payload),
    setTableStateColumns: (state, payload) => (state.tableState.columns = payload)
  },

  actions: {
    getAndSetTableState({ commit }) {
      return apiTo.GET_LIST_VIEW_TABLE_STATE('products').then(({ data }) => {
        commit('setTableStateFilter', data.result.filter)
        commit('setTableStateColumns', data.result.columns)

        return data
      })
    },

    saveTableState({ state }) {
      return apiTo.MODIFY_LIST_VIEW_TABLE_STATE('products', {
        filter: state.tableState.filter,
        columns: state.tableState.columns
      })
    }
  }
}
